export const detailUrl = ({ id }) => `/configcenter/categories/premises-statuses/${id}`;
